import React, { Fragment } from 'react'
import style from './style.module.less'
import EditorPanel from '../EditorPanel'
import UploadField from '@common/UploadField'
import VideoUploader from '../../Content/VideoUploader'

const videoIcon = '//qnm.hunliji.com/o_1dc13ugdu1cu5j59uht1g571dum9.png'
const getInnerHtml = (
  { type, text, title, link, cover_path },
  editable,
  showTips
) => {
  switch (type) {
    case 'title':
      return (
        <Fragment>
          {((editable && showTips) || title) && (
            <div
              className={style.titlecontainer}
              dangerouslySetInnerHTML={{
                __html: `<span className=${style.titlespan}>${
                  title ? title : '<span style="color: #aaa">标题</span>'
                }</span>`
              }}
            />
          )}
          {((editable && showTips) || text) && (
            <div
              className={style.container}
              dangerouslySetInnerHTML={{
                __html: text || '<p style="color: #aaa">请在右侧编辑详情</p>'
              }}
            />
          )}
        </Fragment>
      )
    case 'img':
      return (
        <img
          className={style.showPath}
          src={link + '?imageView2/2/w/400'}
          style={{ padding: '0 12px' }}
        />
      )
    case 'video':
      return (
        <div className={style.videoInfo}>
          <img className={style.videoIcon} src={videoIcon} />
          <img className={style.showPath} src={`${cover_path}`} />
        </div>
      )
  }
}

export default props => {
  const {
    index,
    maxLength,
    item,
    editable,
    replaceCaseContentImage,
    replaceCaseContentVideo,
    onClick,
    onMoveUp,
    onMoveDown,
    onDelete
  } = props
  const { type, active, showTips } = item
  const auth = editable && active
  return (
    <div
      className={style.panel}
      id={auth && type == 'title' ? 'static-title-content' : ''}
    >
      <div className={style.imageGroup}>
        {auth && (
          <div className={style.mask}>
            {type == 'img' && (
              <UploadField
                onOk={replaceCaseContentImage(index)}
                filters={{
                  mime_types: [
                    {
                      title: 'images files',
                      extensions: 'jpg,png,jpeg,bmp'
                    }
                  ],
                  max_file_size: '15mb',
                  prevent_duplicates: true
                }}
              >
                {({ provided }) => (
                  <div className={style.maskBtn} {...provided}>
                    更换<br />图片
                  </div>
                )}
              </UploadField>
            )}
            {type == 'video' && (
              <VideoUploader onChange={replaceCaseContentVideo(index)}>
                <div className={style.maskBtn}>
                  更换<br />视频
                </div>
              </VideoUploader>
            )}
          </div>
        )}
        <div className={style.imageGroup} onClick={() => onClick(index)}>
          {getInnerHtml(item, editable, showTips)}
        </div>
      </div>
      {auth &&
        (type == 'title' && (
          <EditorPanel
            index={index}
            panelStyle={
              index > 1 && index == maxLength - 1 ? { bottom: 0 } : { top: 0 }
            }
            maxLength={maxLength}
            onDelete={onDelete}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            // onCopy={onCopy}
          />
        ))}
      {auth &&
        ((type == 'img' || type == 'video') && (
          <EditorPanel
            index={index}
            panelStyle={{ top: 0 }}
            maxLength={maxLength}
            onDelete={onDelete}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            // onAddText={onAddText}
          />
        ))}
    </div>
  )
}
